import { render, staticRenderFns } from "./ClientBillingLetterNotifications.vue?vue&type=template&id=1ebad305&"
import script from "./ClientBillingLetterNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientBillingLetterNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports